module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-authors"
    }
  }, [_c('h1', [_vm._v("About the Authors")]), _vm._v(" "), _c('p', [_vm._v("Niranjan Seshadri and Erika Seshadri live on an animal rescue ranch in Sarasota, Florida, with their three children. In their fleeting moments of spare time, they enjoy writing poetry together. Niranjan’s penchant for adventure and Erika’s love of writing provided the perfect storm in which to create their debut work, "), _c('em', [_vm._v("Himalayan Tsunami.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0